import Vue from 'vue'
import VueRouter from 'vue-router'
import Member from './moudles/member' //会员等级
import Activity from './moudles/activity' //活动
import Services from './moudles/services' //增值服务
import LawyerFlowPacket from './moudles/lawyerFlowPacket' //增值服务
import PlusPage from './moudles/plusPage' //plus会员
import payPage from './moudles/payPage' //plus会员
import picture from './moudles/picture' //临时图片
import Recharge from './moudles/recharge' //充值
import ConfirmOrder from './moudles/confirm-order' //确认订单支付页面
import InvitationPage from './moudles/invitationPage' //确认订单支付页面
import Changlvmember from './moudles/changlvmember' //长律会员
import Lvkeyun from './moudles/lvkeyun' //律客云
import caseShareDetail from './moudles/case-share-detail' //长律案件详情分享页面
import SharePages from './moudles/share-page' //分享页面

// import { callApp } from "@/libs/bridge";
import {
  set0sVersionTokenStorage,
  setUserTokenStorage
} from '@/libs/token'
import store from '@/store'
import {
  isObjNull
} from '@/libs/basics-tools.js'
import serverQa from "@/router/moudles/serverQa";


Vue.use(VueRouter)

const routes = [{
    path: '/member',
    name: 'member',
    component: ()=>import('@/views/member/home.vue'),
    children: [
      ...Member
    ],
  },
  {
    path: '/activity',
    name: 'activityHome',
    component: ()=>import('@/views/activity/home.vue'),
    children: [
      ...Activity
    ],
  },
  {
    path: '/services',
    name: 'servicesHome',
    component: ()=>import('@/views/services/home.vue'),
    children: [
      ...Services
    ],
  },
  {
    path: '/source',
    name: 'lawyerFlow',
    component: () => import('@/views/lawyerFlowPacket/home.vue'),
    children: [
      ...LawyerFlowPacket
    ],
  },
  {
    path: '/novice-tutorial',
    name: 'noviceTutorial',
    meta:{
      activity:true,
      title: '新手教程'
    },
    component: ()=>import('@/views/novice-tutorial/index.vue'),
  },
  {
    path: '/plusVIP',
    name: 'plusVIP',
    meta: {
      activity: true,
      title: '长律plus会员'
    },
    component: () => import('@/views/plusPage/home.vue'),
    children: [
      ...PlusPage
    ]
  },
  {
    path: '/poster',
    name: 'poster',
    meta: {
      activity: true,
      title: '海报'
    },
    component: () => import('@/views/poster.vue'),
  },
  {
    path: '/invitationCard',
    name: 'invitationCard',
    meta: {
      activity: true,
      title: '邀请函'
    },
    component: () => import('@/views/invitation-card/index.vue'),
  },
  {
    path: '/pay',
    name: 'pay',
    meta: {
      activity: true,
      title: '确认购买'
    },
    component: () => import('@/views/payPage/home.vue'),
    children: [
      ...payPage
    ]
  },
    ...picture,
  {
    path: '/recharge',
    meta: {
      title: '充值'
    },
    component: () => import('@/views/recharge/home.vue'),
    children: [
      ...Recharge
    ]
  },
  {
    path: '/changlvmember',
    meta: {
      title: '充值'
    },
    component: () => import('@/views/changlvmember/home.vue'),
    children: [
      ...Changlvmember
    ]
  },
  {
    path: '/lvkeyun',
    meta: {
      title: '充值'
    },
    component: () => import('@/views/lvkeyun/home.vue'),
    children: [
      ...Lvkeyun
    ]
  },
  {
    path: '/confirm-order',
    name: 'ConfirmOrder',
    meta: {
      title: '确认订单'
    },
    component: () => import('@/views/confirm-order/home.vue'),
    children: [
      ...ConfirmOrder
    ]
  },
  ...InvitationPage,
  {
    path: '/toutiao-download',
    name: 'toutiaoDownload',
    meta: {
      title: '法临下载',
      activity: true
    },
    component: () => import('@/views/toutiao-download/index.vue')
  },
  ...caseShareDetail,
  ...serverQa,
  ...SharePages,
]

const router = new VueRouter({
  // mode:"history",
  routes
})

router.beforeEach((to, form, next) => {
  // window.location.href = 'https://testapph5.imlaw.cn/#/recharge'
  const {token , osVersion} = to.query;
  if (token) {
    setUserTokenStorage(token)
  }
  /* 存路由上带的osVersion */
  if(osVersion) set0sVersionTokenStorage(osVersion)

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if(isObjNull(store.getters.getAppHeaderInfo)){
    // 获取app的头部信息
    window['GET_HEADER_INFO_APP'] = (json) =>{
      const data = JSON.parse(json);
      console.log(data,'获取头部信息')
      setUserTokenStorage(data.token)
      console.log('setToken',data.token)
      store.dispatch('setAppHeaderInfos',data)
      next()
    }
    // const WhiteNames = ['recharge']
    // if(WhiteNames.includes(to.name)) {
    //   setUserTokenStorage(token)
    //   store.dispatch('setAppHeaderInfos',{osVersion: to.query.osVersion})
    //   next()
    // }
    // next()//TODO:删除
    // callApp('getAppHeaderInfo').then((json) =>{
    //   const data = JSON.parse(json);
    //   console.log(data,'获取头部信息')
    //   setUserTokenStorage(data.token)
    //   store.dispatch('setAppHeaderInfos',data)
    //   next()
    // }).catch(() => {
    //   next()
    // })
  }else{
    next()
  }
  // TODO 临时解决 非嵌套页 路由跳转问题
  // activity = true 为普通活动页面
  if(to.meta.activity) {
    next()
  }
})
export default router
